// Service d'authentification
const API_BASE = '/api';

class AuthService {
  constructor() {
    this.token = localStorage.getItem('bastion_token');
    this.user = this.token ? this.parseJWT(this.token) : null;
  }

  // Utilitaire pour parser un JWT côté client (attention : pas de validation)
  parseJWT(token) {
    try {
      const base64Url = token.split('.')[1];
      const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
      const jsonPayload = decodeURIComponent(atob(base64).split('').map(function(c) {
        return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
      }).join(''));
      return JSON.parse(jsonPayload);
    } catch (error) {
      return null;
    }
  }

  // Headers avec authentification
  getAuthHeaders() {
    return {
      'Content-Type': 'application/json',
      ...(this.token && { 'Authorization': `Bearer ${this.token}` })
    };
  }

  // Connexion
  async login(username, password) {
    try {
      const response = await fetch(`${API_BASE}/auth/login`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ username, password }),
      });

      const data = await response.json();

      if (response.ok) {
        this.token = data.token;
        this.user = data.user;
        localStorage.setItem('bastion_token', data.token);
        localStorage.setItem('bastion_user', JSON.stringify(data.user));
        return { success: true, user: data.user };
      } else {
        return { success: false, error: data.error };
      }
    } catch (error) {
      console.error('Erreur lors de la connexion:', error);
      return { success: false, error: 'Erreur de connexion' };
    }
  }

  // Déconnexion
  async logout() {
    try {
      if (this.token) {
        await fetch(`${API_BASE}/auth/logout`, {
          method: 'POST',
          headers: this.getAuthHeaders(),
        });
      }
    } catch (error) {
      console.error('Erreur lors de la déconnexion:', error);
    }

    this.token = null;
    this.user = null;
    localStorage.removeItem('bastion_token');
    localStorage.removeItem('bastion_user');
  }

  // Vérifier si connecté
  isAuthenticated() {
    if (!this.token) return false;
    
    try {
      const payload = this.parseJWT(this.token);
      return payload && payload.exp * 1000 > Date.now();
    } catch (error) {
      return false;
    }
  }

  // Obtenir l'utilisateur actuel
  getCurrentUser() {
    return this.user || JSON.parse(localStorage.getItem('bastion_user') || 'null');
  }

  // Obtenir le token
  getToken() {
    return this.token;
  }

  // Vérifier si admin
  isAdmin() {
    const user = this.getCurrentUser();
    return user && user.role === 'admin';
  }

  // Vérifier le token côté serveur
  async verifyToken() {
    try {
      const response = await fetch(`${API_BASE}/auth/verify`, {
        headers: this.getAuthHeaders(),
      });
      return response.ok;
    } catch (error) {
      return false;
    }
  }
}

export default new AuthService();
